<template>
  <div>
    <div style="margin-top: -24px; margin-left: 15px">
      <el-input
        size="small"
        :placeholder="placeholder"
        style="width: 400px"
        @keyup.enter="handleSearchByText"
        v-model="searchText"
      >
        <template #append>
          <el-button @click="handleSearchByText"
            ><i class="iconfont icon-sousuo"></i> <span>查询</span></el-button
          >
        </template>
      </el-input>
      <div
        :id="param.name + 'chart'"
        style="width: 100%; height: 18px; margin-top: 5px"
      ></div>
    </div>

    <div v-loading="loading" class="table-wrapper">
      <el-button
        link
        type="primary"
        style="position: absolute; right: 15px; z-index: 2"
        @click="handleShowAbGraph"
        >显示关系依赖图</el-button
      >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="contain_assets">
          <template #label>
            <span style="font-size: 12px">资源</span>
          </template>
          <el-table
            @sort-change="handleSortChange"
            :data="optionData.contain_assets.list"
            height="calc(100vh - 333px)"
            size="default"
            border
          >
            <el-table-column width="66">
              <template #default="scope">
                <el-button
                  @click="handleRowClick(scope.row)"
                  link
                  type="primary"
                  size="small"
                  style="padding: 0"
                >
                  <i class="iconfont icon-level-down"></i>
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="asset_path" label="文件路径">
            </el-table-column>
            <el-table-column
              prop="file_size"
              label="文件大小"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ humanSizePackage(scope.row.file_size) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="dependencies_bundles"
              label="总依赖AB包"
              sortable="custom"
              width="130"
            >
            </el-table-column>
            <el-table-column
              prop="dependencies_bundles"
              label="直接依赖AB包"
              sortable="custom"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="dependencies_assets"
              label="依赖的资源数"
              sortable="custom"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="inverse_dependencies_assets"
              label="被引用次数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination
              background
              :page-size="optionData.contain_assets.count"
              :current-page="optionData.contain_assets.cursor"
              :total="optionData.contain_assets.total"
              @current-change="pagechange"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="all_dependencies_bundles">
          <template #label>
            <span style="font-size: 12px">总依赖AB包</span>
          </template>
          <el-table
            @sort-change="handleSortChange"
            :data="optionData.all_dependencies_bundles.list"
            height="calc(100vh - 333px)"
            size="default"
            border
          >
            <el-table-column width="66">
              <template #default="scope">
                <el-button
                  @click="handleRowClick(scope.row)"
                  link
                  type="primary"
                  size="small"
                  style="padding: 0"
                >
                  <i class="iconfont icon-level-down"></i>
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="bundle_name" label="AB包名称">
            </el-table-column>
            <el-table-column
              prop="bundle_size"
              label="文件大小"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ humanSizePackage(scope.row.bundle_size) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="contain_assets"
              label="包含资源数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="all_dependencies_bundles"
              label="总依赖AB包"
              sortable="custom"
              width="130"
            >
            </el-table-column>
            <el-table-column
              prop="direct_dependencies_bundles"
              label="直接依赖AB包"
              sortable="custom"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="rev_direct_dependencies_bundles"
              label="被引用次数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination
              background
              :page-size="optionData.all_dependencies_bundles.count"
              :current-page="optionData.all_dependencies_bundles.cursor"
              :total="optionData.all_dependencies_bundles.total"
              @current-change="pagechange"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="direct_dependencies_bundles">
          <template #label>
            <span style="font-size: 12px">直接依赖AB包</span>
          </template>
          <el-table
            @sort-change="handleSortChange"
            :data="optionData.direct_dependencies_bundles.list"
            height="calc(100vh - 333px)"
            size="default"
            border
          >
            <el-table-column width="66">
              <template #default="scope">
                <el-button
                  @click="handleRowClick(scope.row)"
                  link
                  type="primary"
                  size="small"
                  style="padding: 0"
                >
                  <i class="iconfont icon-level-down"></i>
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="bundle_name" label="AB包名称">
            </el-table-column>
            <el-table-column
              prop="bundle_size"
              label="文件大小"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ humanSizePackage(scope.row.bundle_size) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="contain_assets"
              label="包含资源数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="all_dependencies_bundles"
              label="总依赖AB包"
              sortable="custom"
              width="130"
            >
            </el-table-column>
            <el-table-column
              prop="direct_dependencies_bundles"
              label="直接依赖AB包"
              sortable="custom"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="rev_direct_dependencies_bundles"
              label="被引用次数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination
              background
              :page-size="optionData.direct_dependencies_bundles.count"
              :current-page="optionData.direct_dependencies_bundles.cursor"
              :total="optionData.direct_dependencies_bundles.total"
              @current-change="pagechange"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="rev_dependencies_scenes">
          <template #label>
            <span style="font-size: 12px">被引用场景</span>
          </template>
          <el-table
            @sort-change="handleSortChange"
            :data="optionData.rev_dependencies_scenes.list"
            height="calc(100vh - 333px)"
            size="default"
            border
          >
            <el-table-column width="66">
              <template #default="scope">
                <el-button
                  @click="handleRowClick(scope.row)"
                  link
                  type="primary"
                  size="small"
                  style="padding: 0"
                >
                  <i class="iconfont icon-level-down"></i>
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="scene_name" label="场景名称" width="140">
            </el-table-column>
            <el-table-column prop="scene_path" label="场景路径">
            </el-table-column>
            <el-table-column
              prop="dependencies_bundles"
              label="依赖的AB包"
              sortable="custom"
              width="130"
            >
            </el-table-column>
            <el-table-column
              prop="dependencies_assets"
              label="依赖的资源"
              sortable="custom"
              width="120"
            >
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination
              background
              :page-size="optionData.rev_dependencies_scenes.count"
              :current-page="optionData.rev_dependencies_scenes.cursor"
              :total="optionData.rev_dependencies_scenes.total"
              @current-change="pagechange"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane name="rev_direct_dependencies_bundles">
          <template #label>
            <span style="font-size: 12px">被直接依赖</span>
          </template>
          <el-table
            @sort-change="handleSortChange"
            :data="optionData.rev_direct_dependencies_bundles.list"
            height="calc(100vh - 333px)"
            size="default"
            border
          >
            <el-table-column width="66">
              <template #default="scope">
                <el-button
                  @click="handleRowClick(scope.row)"
                  link
                  type="primary"
                  size="small"
                  style="padding: 0"
                >
                  <i class="iconfont icon-level-down"></i>
                  查看
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="bundle_name" label="AB包名称">
            </el-table-column>
            <el-table-column
              prop="bundle_size"
              label="文件大小"
              sortable="custom"
              width="120"
            >
              <template #default="scope">
                {{ humanSizePackage(scope.row.bundle_size) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="contain_assets"
              label="包含资源数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="all_dependencies_bundles"
              label="总依赖AB包"
              sortable="custom"
              width="130"
            >
            </el-table-column>
            <el-table-column
              prop="direct_dependencies_bundles"
              label="直接依赖AB包"
              sortable="custom"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="rev_direct_dependencies_bundles"
              label="被引用次数"
              sortable="custom"
              width="120"
            >
            </el-table-column>
          </el-table>
          <div class="pagination-wrapper">
            <el-pagination
              background
              :page-size="optionData.rev_direct_dependencies_bundles.count"
              :current-page="optionData.rev_direct_dependencies_bundles.cursor"
              :total="optionData.rev_direct_dependencies_bundles.total"
              @current-change="pagechange"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script setup>
import {
  onMounted,
  onBeforeUnmount,
  reactive,
  ref,
  defineEmits,
  defineProps,
  computed,
} from "vue";
import { humanSizePackage } from "@/Utils/UtilTools";
import {
  apiPackageParseAssetsuffix,
  apiPackageParseDependency,
} from "@/Api/AppApi";
import * as echarts from "echarts";

const props = defineProps(["param"]);
const emit = defineEmits(["showGraph", "selectRow"]);

const optionData = reactive({
  contain_assets: {
    list: [],
    cursor: 1,
    count: 30,
    total: 0,
    searchcolumn: "asset_path",
    viewType: "assetsdetail",
  },
  all_dependencies_bundles: {
    list: [],
    cursor: 1,
    count: 30,
    total: 0,
    searchcolumn: "bundle_name",
    viewType: "boundledetail",
  },
  direct_dependencies_bundles: {
    list: [],
    cursor: 1,
    count: 30,
    total: 0,
    searchcolumn: "bundle_name",
    viewType: "boundledetail",
  },
  rev_dependencies_scenes: {
    list: [],
    cursor: 1,
    count: 30,
    total: 0,
    searchcolumn: "scene_path",
    viewType: "scenedetail",
  },
  rev_direct_dependencies_bundles: {
    list: [],
    cursor: 1,
    count: 30,
    total: 0,
    searchcolumn: "bundle_name",
    viewType: "boundledetail",
  },
});

const searchText = ref("");
function handleSearchByText() {
  optionData.contain_assets.cursor = 1;
  optionData.contain_assets.count = 30;
  optionData.all_dependencies_bundles.cursor = 1;
  optionData.all_dependencies_bundles.count = 30;
  optionData.direct_dependencies_bundles.cursor = 1;
  optionData.direct_dependencies_bundles.count = 30;
  optionData.rev_dependencies_scenes.cursor = 1;
  optionData.rev_dependencies_scenes.count = 30;
  optionData.rev_direct_dependencies_bundles.cursor = 1;
  optionData.rev_direct_dependencies_bundles.count = 30;
  loadData(searchText.value);
}

const activeName = ref("contain_assets");
onMounted(() => {
  activeName.value = "contain_assets";
  loadChartData();
  loadData();
});

onBeforeUnmount(() => {
  if (myChart) {
    myChart.dispose();
    myChart = null;
  }
});

const placeholder = computed(() => {
  if (activeName.value.includes("assets")) {
    return "输入文件路径查询";
  } else if (activeName.value.includes("scenes")) {
    return "输入场景路径查询";
  } else {
    return "输入AB包名称查询";
  }
});

let sortColumn = "";
let order = "";
function handleClick(tabevent) {
  activeName.value = tabevent.props.name;
  searchText.value = "";
  sortColumn = "";
  order = "";
  loadData();
}

function handleShowAbGraph() {
  emit("showGraph", props.param);
}

function handleSortChange(event) {
  sortColumn = event.prop;
  order = event.order;
  loadData(searchText.value);
}

function handleRowClick(row) {
  const data = {
    viewType: optionData[activeName.value].viewType,
    name: row[optionData[activeName.value].searchcolumn],
    type: row.type,
    deftab: "",
  };
  emit("selectRow", data);
}

function pagechange(pagenum) {
  optionData[activeName.value].cursor = pagenum;
  loadData(searchText.value);
}

async function loadChartData() {
  const params = {
    version_id: props.param.versionid,
    bundle_name: props.param.name,
  };
  const res = await apiPackageParseAssetsuffix(params);
  if (res.code === 0) {
    drawChart(res.data);
  }
}
let myChart = null;
const option = {
  color: [
    "#8BE8C9",
    "#fed698",
    "#98a3fc",
    "#c5e59a",
    "#97effd",
    "#7282fd",
    "#773a91",
    "#e10000",
  ],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
    formatter(params) {
      let res = "";
      for (const param of params) {
        res +=
          param.marker +
          param.data.name +
          " : " +
          param.data.realvalue +
          "<br/>";
      }
      return res;
    },
  },
  legend: {
    show: false,
    data: [],
  },
  toolbox: {
    show: false,
  },
  calculable: false,
  xAxis: [
    {
      type: "value",
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
  ],
  yAxis: [
    {
      type: "category",
      data: ["分类"],
      axisLine: {
        show: false,
      },
      axisLabel: {
        show: true,
        fontSize: 14,
        verticalAlign: "top",
      },
    },
  ],
  grid: {
    left: 4,
    right: 15,
    containLabel: true,
  },
  series: [],
};
function drawChart(data) {
  if (myChart == null) {
    myChart = echarts.init(document.getElementById(props.param.name + "chart"));
  }
  calculationdrawvalue(data);
  let seriesdata = [];
  let legend = [];
  for (const dataItem of data) {
    legend.push(dataItem.name);
    const item = {
      value: dataItem.drawvalue,
      realvalue: dataItem.value,
      name: dataItem.name,
    };
    seriesdata.push({
      name: dataItem.name,
      type: "bar",
      stack: "分类",
      emphasis: {
        label: {
          show: false,
        },
      },
      label: {
        show: false,
      },
      data: [item],
    });
  }
  option.series = seriesdata;
  myChart.setOption(option);
}
function calculationdrawvalue(data) {
  // 计算绘制图形用的百分比
  let sum = 0;
  let num = 0;
  for (const item of data) {
    sum += item.value;
  }
  for (let i = 0; i < data.length; i++) {
    if (i < data.length - 1) {
      data[i].drawvalue = Math.round((data[i].value * 100) / sum);
      num += data[i].drawvalue;
    } else {
      data[i].drawvalue = 100 - num;
    }
  }
}

const loading = ref(false);
async function loadData(search) {
  const name = activeName.value;
  const params = {
    name: props.param.name,
    version_id: props.param.versionid,
    type: "bundle",
    tab: name,
    cursor: optionData[name].cursor,
    count: optionData[name].count,
  };

  if (search != undefined && search.length > 0) {
    params.search_key = optionData[name].searchcolumn;
    params.search_value = search;
  }
  if (sortColumn != undefined && sortColumn.length > 0) {
    params.sort_field = sortColumn;
  }
  if (order != undefined && order.length > 0) {
    params.order = order;
  }
  loading.value = true;
  const res = await apiPackageParseDependency(params);
  loading.value = false;

  if (res.code === 0) {
    optionData[name].list = res.data.list;
    optionData[name].total = res.data.total;
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  margin-top: 8px;
  width: 100%;
  background: #fff;
  padding: 15px 15px 0 15px;
  height: calc(100vh - 214px);

  :deep() {
    .el-table__inner-wrapper,
    .el-scrollbar__wrap {
      height: 100% !important;
    }

    .el-table__body-wrapper {
      height: calc(100% - 40px) !important;
    }
  }
}

.pagination-wrapper {
  display: flex;
  background-color: #ffffff;
  justify-content: center;
  padding: 5px 0;
  height: 46px;
}
</style>
